import Swal from 'sweetalert2';
import guestService from '../../services/api/guest';
import eventService from '../../services/api/eventService';
import ExperienceService from '../../services/api/experienceService';
import groupService from '../../services/api/groupService';
export const getGuest = async ({ identification, phone, captcha, setGuest, setCrecer }) => {
  try {
    const response = await guestService.getGuest(
      `${identification}/${phone}`,
      `crecer/crecerAttendance`,
      {
        eventSlugname: 'crecerAttendance',
        captcha,
      }
    );
    if (response.data?.success && response.data.Attendant) {
      setGuest({ ...response.data.Attendant });
      return true;
    }
    Swal.fire(
      response.data?.message ||
        'No se encontró el usuario. Verifica que la identificación y el celular estén escritos correctamente.'
    );
    return false;
  } catch (error) {
    Swal.fire(
      error.response?.data?.message ||
        'No se encontró el usuario. Verifica que la identificación y el celular estén escritos correctamente.'
    );
    return false;
  }
};

export const getCrecerDates = async ({ setCrecerDates }) => {
  eventService
    .getDates()
    .then((response) => {
      if (response.data.success) {
        setCrecerDates(response.data.dates);
      }
    })
    .catch((error) => {
      if (error.response) Swal.fire(error.response.data.message);
    });
};

export const getAVolunteer = async ({ identification, phone, setExperienceVolunteer }) => {
  const body = {
    identification,
    phone,
  };
  ExperienceService.getAVolunteer(body)
    .then((response) => {
      if (response.data.success) {
        setExperienceVolunteer(response.data.volunteer);
      }
    })
    .catch((error) => {
      if (error.response) Swal.fire(error.response.data.message);
    });
};

export const getGuestGroup = async ({ identification, phone, captcha, setGuestGroup }) => {
  const body = {
    identification,
    phone,
    ...(captcha ? { captcha } : {}),
  };
  groupService
    .getGroupAttendant(body)
    .then((response) => {
      if (response.data.success) {
        setGuestGroup(response.data);
      }
    })
    .catch((error) => {
      if (error.response) Swal.fire(error.response.data.message);
    });
};

export const getGuestGroups = async ({ identification, phone, captcha, setGuestGroups }) => {
  const body = {
    identification,
    phone,
    ...(captcha ? { captcha } : {}),
  };
  groupService
    .getAllGroups(body)
    .then((response) => {
      if (response.data.success) {
        setGuestGroups(response.data.groups);
      }
    })
    .catch((error) => {
      if (error.response) Swal.fire(error.response.data.message);
    });
};
